import {useEffect, useRef, useState} from 'react';
import {Box, Button, createTheme, FormControl, FormHelperText, Grid, IconButton, LinearProgress, MenuItem, Stack, TextField, ThemeProvider, Typography} from '@mui/material';
import {makeStyles} from "@mui/styles";
import {goldErrorFieldSx, useStyles as useSharedStyles} from '../../../utils/uiUtils';
import {tapeFormatValidationRules, tapeNumberOfBoxesValidationRules, tapeNumberValidationRules, tapeTypeValidationRules} from '../../../utils/validationRules';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import MuiToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {styled} from "@mui/material/styles";
import {useFieldArray} from 'react-hook-form';
import {Close} from '@mui/icons-material';
import {flexStyles} from '../../../component/theme/theme';
import {BACKUP_FORMATS, MEDIA_TYPES} from '../../../utils/constants';
import {createJobDocument, deleteJobDocument, deleteTape as deleteTapeApi} from '../../../utils/apiCalls';

const adminTapeTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    '&.fileUploadBtn': {
                        height: '64px',
                        width: '164px',
                        borderRadius: '8px',
                        border: '1px solid #FFFFFF',
                        color: '#FFFFFF',
                        textTransform: 'none',
                        fontSize: '14px',
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                        lineHeight: '24px'
                    }
                }
            }
        }
    }
});

const mediaTypes = MEDIA_TYPES;

const backupFormats = BACKUP_FORMATS;

const allowedMimeTypes = [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
];

const FileInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const AdminTapeForm = (props) => {

    const {fields: tapeFields, append: appendTape, prepend, remove: removeTape, swap, move, insert} = useFieldArray({
        control: props.control,
        name: 'tape.tapeDetails'
    });

    const classes = useStyles();
    const sharedClasses = useSharedStyles();
    let _orderUUID = window?.location?.href?.split("uuid=")[1];
    const [tapeDetails, setTapeDetails] = []; //TODO evaluate controlled vs local

    const [numberOfBoxes, setNumberOfBoxes] = useState(0);

    const [typeOfBackup, setTypeOfBackup] = useState('virtualize');
    const handleChangeTypeOfBackup = (event, newTypeOfBackup) => {
        if (newTypeOfBackup !== null) {
            props.setValue('tape.backupType', newTypeOfBackup);
        }
    };
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [accountOptions, setAccountOptions] = useState('enterprise');
    const handleChangeAccountOptions = (event, newAccountOptions) => {
        setAccountOptions(newAccountOptions);
    };

    const [volserAvailable, setVolserAvailable] = useState('yes');
    const handleChangeVolserAvailable = (event, newVolserAvailable) => {
        if (newVolserAvailable !== null) {
            props.setValue('tape.volserAvailable', newVolserAvailable);
        }
    };


    //Document upload

    const [tLuuid, setTLuuid] = useState(null);
    useEffect(() => {
        if (props.watch('tape.orderdocuments.tLuuid')) {
            setTLuuid(props.watch('tape.orderdocuments.tLuuid'));
        }
    }, [props.watch('tape.orderdocuments.tLuuid')]);

    useEffect(() => {
        if (props.watch('tape.orderdocuments.tapeList')) {
            setTapeListFile(props.watch('tape.orderdocuments.tapeList'))
        }
    }, [props.watch('tape.orderdocuments.tapeList')]);

    const tapeListControllerRef = useRef(null);

    const [tapeListFile, setTapeListFile] = useState(null);
    const [tapeListFileProgress, setTapeListFileProgress] = useState(0);

    const handleTapeListFileSelect = (e) => {
        console.log(e.target.files);
        if (e.target.files) {
            let selectedFile = e.target.files[0];
            //if (allowedMimeTypes.includes(selectedFile.type)){
            setTapeListFile(selectedFile);
            props.setValue('tape.orderdocuments.tapeList', selectedFile);
            uploadTapeListFile();
            //}          
        }
    };

    const removeTapeListFileAttachment = () => {
        const uuid = tLuuid;
        if (uuid) {
            deleteJobDocument(_orderUUID, uuid).then(() => {
                props.setValue('tape.orderdocuments.tapeList', null);
                setTapeListFile(null);
            }).catch(err => console.log(err));
        }
    };


    const uploadTapeListFile = () => {
        const tapeListFile = props.watch('tape.orderdocuments.tapeList');
        if (_orderUUID !== "undefined") {
            let reader = new FileReader();
            reader.onload = function () {
                const base64String = reader.result;
                const documentPayload = {
                    "name": tapeListFile.name,
                    "file_type": 'tape_list',
                    "order": _orderUUID,
                    "file": base64String.split(',')[1],
                };

                tapeListControllerRef.current = new AbortController();

                createJobDocument(_orderUUID, documentPayload, {
                    onProgress: (progressEvent) => {
                        let percentCompleted = Math.round((100 * progressEvent.loaded) / progressEvent.total);
                        setTapeListFileProgress(percentCompleted);
                    },
                    signal: tapeListControllerRef.current.signal
                }).then((data) => {
                    props.setValue('tape.orderdocuments.tapeList', tapeListFile);
                    props.setValue('tape.orderdocuments.tLuuid', data?.uuid);
                }).catch((err) => {
                    console.log(err);
                    setTapeListFileProgress(0);
                    props.setValue('tape.orderdocuments.tapeList', null);
                    setTapeListFile(null);
                });
            }
            reader.readAsDataURL(tapeListFile);
        }
    };

    const handleDeleteTape = (index) => {
        const uuid = props.watch(`tape.tapeDetails[${index}].uuid`);
        if (uuid) {
            deleteTapeApi(_orderUUID, uuid).then(() => {
                if (tapeFields.length === 1) {
                    props.setValue(`tape.tapeDetails[0]`, {tapeType: '', number: 0, tapeFormat: '', uuid: ''});
                } else {
                    removeTape(index);
                }
            }).catch(err => console.log(err));
        } else {
            if (tapeFields.length === 1) {
                return;
            }
            removeTape(index);
        }
    }

    return (
        <ThemeProvider theme={adminTapeTheme}>
            <Grid
                container
                style={{
                    border: "1px solid #C7CCD0",
                    borderRadius: "8px",
                    marginTop: "20px",
                    minHeight: "100vh",
                    height: "max-content",
                    marginBottom: '100px',
                    alignItems: "start",
                    display: "block",
                }}
            >
                <Grid container direction={"column"}>
                    {/* Stepper */}
                    <Grid item>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "start",
                                border: "8px 8px 0px 0px",
                                border: "#272727",
                                padding: "20px",
                                background: "#272727",
                                borderRadius: "8px 8px 0px 0px",
                            }}
                        >
                            <Typography className={classes.shippingheading}>
                                Media Details
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Box p={4}>
                    <Grid container direction='column' spacing={2} xs={12}>
                        <Grid item>
                            {tapeFields.map((field, index) => (
                                <Grid key={field.id} container direction='row' justifyContent='flex-start' spacing={2} mb={1}>
                                    <Grid item>
                                        <FormControl fullWidth={true}>
                                            <TextField
                                                {...props.register(`tape.tapeDetails[${index}].tapeType`, tapeTypeValidationRules)}
                                                name={`tape.tapeDetails[${index}].tapeType`}
                                                className={sharedClasses.selectLabelGreyDiff}
                                                sx={{width: '15ch', ...(props.errors?.tape?.tapeDetails?.[index]?.tapeType ? goldErrorFieldSx : {})}}
                                                label="Media Type *"
                                                InputLabelProps={{shrink: true}}
                                                defaultValue={field.tapeType}
                                                error={false}
                                                select>
                                                {mediaTypes.map(mediaType => {
                                                    if (mediaType.type === 'subheader') {
                                                        // return (<ListSubheader sx={{background: '#4e5152', color: 'rgba(255,255,255,0.5)'}}>{mediaType.label}</ListSubheader>)
                                                    } else {
                                                        return (<MenuItem key={mediaType.key} value={mediaType.key}>{mediaType.label}</MenuItem>)
                                                    }
                                                })}
                                            </TextField>
                                            {props.errors?.tape?.tapeDetails?.[index]?.tapeType && (
                                                <FormHelperText sx={{mx: 0, color: '#FFC540'}}>{props.errors.tape.tapeDetails[index].tapeType.message}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={1} xs={1}>
                                        <TextField
                                            {...props.register(`tape.tapeDetails[${index}].number`, tapeNumberValidationRules)}
                                            type='number'
                                            name={`tape.tapeDetails[${index}].number`}
                                            defaultValue={field.number}
                                            className={sharedClasses.selectLabelGreyDiff}
                                            sx={props.errors?.tape?.tapeDetails?.[index]?.number ? goldErrorFieldSx : {}}
                                            label="Number *"
                                            InputLabelProps={{shrink: true}}
                                            variant="outlined"
                                            fullWidth={true}
                                            error={false}/>
                                        {props.errors?.tape?.tapeDetails?.[index]?.number && (
                                            <FormHelperText sx={{mx: 0, color: '#FFC540'}}>{props.errors.tape.tapeDetails[index].number.message}</FormHelperText>
                                        )}
                                    </Grid>
                                    <Grid item md={3} xs={3}>
                                        <FormControl fullWidth={true}>
                                            <TextField
                                                className={sharedClasses.selectLabelGreyDiff}
                                                sx={props.errors?.tape?.tapeDetails?.[index]?.tapeFormat ? goldErrorFieldSx : {}}
                                                {...props.register(`tape.tapeDetails[${index}].tapeFormat`, tapeFormatValidationRules)}
                                                name={`tape.tapeDetails[${index}].tapeFormat`}
                                                label="Backup Format *"
                                                InputLabelProps={{shrink: true}}
                                                defaultValue={field.tapeFormat}
                                                error={false}
                                                select>
                                                {backupFormats.map(backupFormat => (
                                                    <MenuItem key={backupFormat.key} value={backupFormat.key}>{backupFormat.label}</MenuItem>
                                                ))}
                                            </TextField>
                                            {props.errors?.tape?.tapeDetails?.[index]?.tapeFormat && (
                                                <FormHelperText sx={{mx: 0, color: '#FFC540'}}>{props.errors.tape.tapeDetails[index].tapeFormat.message}</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item>
                                        <Box mt={3}>
                                            <Button
                                                className={classes.plusMinBtn}
                                                variant="outlined"
                                                onClick={() => {
                                                    handleDeleteTape(index)
                                                }}
                                            >
                                                <DeleteOutlineIcon sx={{color: '#FFFFFF'}}/>
                                            </Button>
                                        </Box>
                                    </Grid>
                                    <Grid item sx={{visibility: (index === tapeFields.length - 1) ? 'visible' : 'hidden'}}>
                                        <Box mt={3}>
                                            <Button
                                                className={classes.plusMinBtn}
                                                variant="outlined"
                                                onClick={() => appendTape({tapeType: '', number: 0, tapeFormat: '', uuid: ''})}
                                            >
                                                <AddIcon sx={{color: '#FFFFFF'}}/>
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item md={3} xs={12} sx={{width: '10%'}}>
                            <TextField
                                {...props.register(`tape.numberOfBoxes`, tapeNumberOfBoxesValidationRules)}
                                className={sharedClasses.selectLabelGreyDiff}
                                sx={props.errors?.tape?.numberOfBoxes ? goldErrorFieldSx : {}}
                                name={`tape.numberOfBoxes`}
                                label="No. of Boxes (max 30 tapes) *"
                                InputLabelProps={{shrink: true}}
                                type='number'
                                fullWidth={true}
                                error={false}
                            />
                            {props.errors?.tape?.numberOfBoxes && (
                                <FormHelperText sx={{mx: 0, color: '#FFC540'}}>{props.errors.tape.numberOfBoxes.message}</FormHelperText>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography align='left' className={classes.heading}>Type of Service</Typography>
                        </Grid>
                        <Grid item md={3} xs={12} display={'flex'} justifyContent={'flex-start'}>
                            <ToggleButtonGroup
                                color="primary"
                                name='tape.backupType'
                                value={props.watch('tape.backupType')}
                                onChange={handleChangeTypeOfBackup}
                                exclusive
                                aria-label="Platform"
                                style={{
                                    borderRadius: "7px",
                                    border: "1px solid #7B809A",
                                    background: "var(--Charcoal, #3A3E3F)",
                                }}
                            >
                                <ToggleButton value="audit_only" className="h-40">
                                    Audit Only
                                </ToggleButton>
                                <ToggleButton value="virtualize" className="h-40" style={{borderLeft: '1px solid #C7CCD0'}}>
                                    Virtualize
                                </ToggleButton>
                                <ToggleButton value="restore" className="h-40" style={{borderLeft: '1px solid #C7CCD0'}}>
                                    Restore
                                </ToggleButton>
                                <ToggleButton value="destruction" className="h-40" style={{borderLeft: '1px solid #C7CCD0'}}>
                                    Destruction
                                </ToggleButton>
                                <ToggleButton value="other" className="h-40" style={{borderLeft: '1px solid #C7CCD0'}}>
                                    Other
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography align='left' className={classes.heading}>Account Options</Typography>
                        </Grid>
                        <Grid item md={3} xs={12} display={'flex'} justifyContent={'flex-start'}>
                            <ToggleButtonGroup
                                color="primary"
                                name='tape.accountOptions'
                                value={props.watch('tape.accountOptions')}
                                onChange={(event, newValue) => props.setValue('tape.accountOptions', newValue)}
                                exclusive
                                aria-label="Platform"
                                style={{
                                    borderRadius: "7px",
                                    border: "1px solid #7B809A",
                                    background: "var(--Charcoal, #3A3E3F)",
                                }}
                            >
                                <ToggleButton value="enterprise" className="h-40" style={{borderLeft: '1px solid #C7CCD0'}}>
                                    Enterprise
                                </ToggleButton>
                                <ToggleButton value="gov_cloud" className="h-40">
                                    Gov't. Cloud
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography align='left' className={classes.heading}>Volser List Available</Typography>
                        </Grid>
                        <Grid item md={3} xs={12} display={'flex'} justifyContent={'flex-start'}>
                            <ToggleButtonGroup
                                color="primary"
                                name={'tape.volser_available'}
                                value={props.watch('tape.volserAvailable')}
                                onChange={handleChangeVolserAvailable}
                                exclusive
                                aria-label="Platform"
                                style={{
                                    borderRadius: "7px",
                                    border: "1px solid #7B809A",
                                    background: "var(--Charcoal, #3A3E3F)",
                                }}
                            >
                                <ToggleButton value={true} className="h-40">
                                    Yes
                                </ToggleButton>
                                <ToggleButton value={false} className="h-40" style={{borderLeft: '1px solid #C7CCD0'}}>
                                    No
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid item>
                            <Typography align='left' mt={4} mb={2} className={classes.heading}>Uploads</Typography>
                        </Grid>
                        <Grid item>
                            <Grid container direction='row' justifyContent='flex-start' alignItems={'center'}>
                                <Grid item xs={2}>
                                    <Typography align='left' className={classes.heading2}>Tape List</Typography>
                                </Grid>
                                <Grid item xs={10} sx={flexStyles.flexRowStart}>
                                    {(tapeListFile) ? (
                                        (tapeListFileProgress > 0 && tapeListFileProgress < 100) ? (
                                            <Stack direction={'row'} width={'100%'} alignItems={'center'}>
                                                <LinearProgress variant='determinate' value={tapeListFileProgress} sx={{
                                                    backgroundColor: '#3A3E3F',
                                                    height: 15,
                                                    borderRadius: 8,
                                                    width: '25%',
                                                    border: '2px solid #FFFFFF',
                                                    '& .MuiLinearProgress-root': {
                                                        borderColor: '#FFFFFF',
                                                    },
                                                    '& .MuiLinearProgress-bar': {
                                                        backgroundColor: '#5F5F5F',
                                                    }
                                                }}/>
                                                <IconButton onClick={() => {
                                                    tapeListControllerRef.current?.abort();
                                                    removeTapeListFileAttachment();
                                                }}><Close sx={{color: '#FFFFFF'}}/></IconButton>
                                            </Stack>
                                        ) : (
                                            <Stack direction={'row'} sx={{
                                                height: '64px',
                                                width: '218px',
                                                borderRadius: '8px',
                                                background: '#C7CCD0',
                                                color: '#3A3E3F',
                                                alignItems: 'center',
                                            }}>
                                                <Typography width={'90%'} sx={{fontFamily: 'Poppins', fontSize: '14px', lineHeight: '24px', fontWeight: 400}}>{tapeListFile?.name}</Typography>
                                                <IconButton width={'10%'} onClick={() => {
                                                    removeTapeListFileAttachment()
                                                }}><Close/></IconButton>
                                            </Stack>
                                        )
                                    ) : (
                                        <Button
                                            component='label'
                                            variant='outlined'
                                            className='fileUploadBtn'>
                                            Upload File
                                            <FileInput
                                                type='file'
                                                name='tape.orderdocuments.tapeList'
                                                //{...props.register('tape.orderdocuments.tapeList')} 
                                                multiple
                                                onChange={handleTapeListFileSelect}/>
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        {/*                         <Grid item>
                            <Grid container direction='row' justifyContent='flex-start'  alignItems={'center'}>
                                <Grid item xs={2}>
                                    <Typography align='left' className={classes.heading2}>Encryption Keys</Typography>
                                </Grid>
                                <Grid item xs={10} sx={flexStyles.flexRowStart}>
                                    <Button variant='outlined' className='fileUploadBtn'>Upload File</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction='row' justifyContent='flex-start'  alignItems={'center'}>
                                <Grid item xs={2}>
                                    <Typography align='left' className={classes.heading2}>S3 Amazon Account</Typography>
                                </Grid>
                                <Grid item xs={10} sx={flexStyles.flexRowStart}>
                                    <Button variant='outlined' className='fileUploadBtn'>Upload File</Button>
                                </Grid>
                            </Grid>
                        </Grid> */}
                    </Grid>
                </Box>
            </Grid>
        </ThemeProvider>
    )
}
export const ToggleButton = styled(MuiToggleButton)({
    "&.MuiToggleButton-root.Mui-selected": {
        backgroundColor: "#ffc540",
        // borderRadius: "8px",
        color: "#3a3e3f",
        fontWeight: 600,
        fontSize: "14px",
    },
    "&.MuiToggleButton-root": {
        // color: "#404558",
        borderRadius: "8px",
        textTransform: "none !important",
        height: "5em !important",
        fontSize: "14px",
        width: "164px",
        // border-radius: 8px;
        background: "#3a3e3f",
        color: " #C7CCD0",
        fontFamily: '"Poppins", sans-serif !important',
    },
    "&.shippingSelection": {
        height: "64px !important",
    }
});
const useStyles = makeStyles({
    selectLabel: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderRadius: '8px',
                borderColor: '#C7CCD0',
            },
            '&:hover fieldset': {
                borderColor: '#C7CCD0',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#C7CCD0',
            }
        },
        '& .MuiOutlinedInput-input': {
            color: '#FFFFFF',
        },
        '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.5)',
            '&.Mui-focused': {
                color: '#FFC540'
            },
        },
        '& svg': {
            color: '#FFFFFF'
        }
    },
    shippingheading: {
        color: "#fff",
        fontSize: "20px !important",
        fontWeight: "700 !important",
        fontFamily: '"Poppins", sans-serif !important',
    },
    plusMinBtn: {
        borderRadius: "3",
        border: " 1px solid #7B809A  !important",
        background: "var(--Charcoal, #3A3E3F)",
        width: "43px !important",
        height: "52px",
        minWidth: "47px !important",
    },
    heading: {
        fontSize: '14px',
        fontWeight: 400,
        color: '#C7CCD0',
        lineHeight: '24px',
        fontFamily: 'Poppins !important',
    },
    heading2: {
        fontSize: '14px',
        fontWeight: 400,
        color: '#FFFFFF',
        lineHeight: '24px',
        fontFamily: 'Poppins !important',
    },
    selectLabel: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderRadius: '8px',
                borderColor: '#C7CCD0',
            },
            '&:hover fieldset': {
                borderColor: '#C7CCD0',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#C7CCD0',
            }
        },
        '& .MuiOutlinedInput-input': {
            color: '#FFFFFF',
        },
        '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.5)',
            '&.Mui-focused': {
                color: '#FFC540'
            },
        },
        '& svg': {
            color: '#FFFFFF'
        }
    },
});